import { configFetch as fetch } from '@laigu/utils';

const statusMap = {
  conv_wait_first_reply: 'firstMessageNotReply',
  conv_redirect: 'redirect',
  conv_atme: 'atMe'
};

export const getConvStatusApi = ({ convIds, flags }) => {
  return fetch({
    url: '/conversation/sign',
    method: 'post',
    data: {
      conv_ids: convIds,
      flags
    }
  }).then(res => {
    const { data } = res;
    if (data && data.data && data.data.length) {
      return data.data.map(val => {
        const { conv_id, flags } = val;
        const props = flags.reduce((prev, now) => {
          return {
            [statusMap[now]]: true,
            ...prev
          };
        }, {});
        return {
          convId: conv_id,
          ...props
        };
      });
    }
    return (data && data.data) || [];
  });
};

export const removeConvStatusApi = ({ convId, flag }) => {
  return fetch({
    url: '/conversation/sign',
    method: 'DELETE',
    data: {
      conv_id: convId,
      flag
    }
  });
};

export const getConversationApi = ({ convId }) => {
  return fetch({
    url: `/conversation/${convId}`
  });
};
